import { useEffect, useState } from 'react';

// Тема хранится в data-theme на <html> (переключатель в навбаре).
// Графики recharts принимают цвета строками, поэтому палитру считаем в JS.
const readMode = () =>
  document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';

export const useThemeMode = () => {
  const [mode, setMode] = useState(readMode);

  useEffect(() => {
    const observer = new MutationObserver(() => setMode(readMode()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  return mode;
};

export const useChartPalette = () => {
  const mode = useThemeMode();
  const dark = mode === 'dark';

  return {
    mode,
    line: dark ? '#f8fafc' : '#0f172a',
    lineSoft: dark ? 'rgba(248, 250, 252, 0.55)' : 'rgba(15, 23, 42, 0.45)',
    grid: dark ? 'rgba(148, 163, 184, 0.18)' : 'rgba(148, 163, 184, 0.28)',
    axis: dark ? '#94a3b8' : '#64748b',
    tooltipBg: dark ? '#0f172a' : '#ffffff',
    tooltipBorder: dark ? 'rgba(148, 163, 184, 0.25)' : 'rgba(148, 163, 184, 0.3)',
    tooltipText: dark ? '#f1f5f9' : '#0f172a',
    series: {
      primary: '#2563eb',
      success: '#10b981',
      warning: '#f59e0b',
      purple: '#a855f7',
    },
  };
};

export default useThemeMode;
